import React, {useRef} from 'react';
import {Card, Col, Container, Row} from 'react-bootstrap';
import {useNavigate} from "react-router-dom";
import ApiService from "../../api/ApiService";
import {toast} from "react-toastify";
import SVipModal from "../../components/SVipModal";

export default function CourseList() {
    const navigate = useNavigate();
    // 获取当前屏幕宽度
    const [isMobile, setIsMobile] = React.useState(false);
    const [showSVipModal, setShowSVipModal] = React.useState(false);//开通SVIP

    const api = new ApiService();

    const [tagList, setTagList] = React.useState([]);
    const [coursesByTag, setCoursesByTag] = React.useState({}); // 新增状态：按标签存储课程

    const videoRefs = useRef({}); // 使用对象存储每个视频的ref

    function getCourseTags() {
        api.getCourseTags().then(res => {
            if (res.code === 200) {
                console.log(res.data);
                setTagList(res.data);
                res.data.forEach(tag => {
                    getCourseList(tag)
                })
            } else if (res.code === -4001) {
                toast.error('请先登录');
            } else if (res.code !== 200) {
                toast.error(res.msg);
            }
        });
    }

    function getCourseList(tag) {
        api.getCourseList([tag.id], 200, 1).then(res => {
            if (res.code === 200) {
                console.log(res.data);
                // 新增逻辑：将课程数据按标签ID存储
                setCoursesByTag(prev => ({
                    ...prev,
                    [tag.id]: res.data
                }));
            } else if (res.code === -4001) {
                toast.error('请先登录');
            } else if (res.code !== 200) {
                toast.error(res.msg);
            }
        });
    }

    // 新增：使用 useRef 来存储是否已经加载过的状态
    const isLoaded = useRef(false);

    React.useEffect(() => {
        const handleResize = () => {
            // 使用 setTimeout 实现简单的防抖
            const timer = setTimeout(() => {
                setIsMobile(window.innerWidth < 768);
            }, 100);

            return () => clearTimeout(timer);
        };
        handleResize(); // 初始化时调用

        window.addEventListener('resize', handleResize);
        // 修改：确保只加载一次
        if (!isLoaded.current) {
            getCourseTags();
            isLoaded.current = true;
        }

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    return (
        <Container className={'card-container'}>
            {/* 内容区域 */}
            {tagList.map((tag, index) => (
                <div key={tag.id} className="tag-container">
                    <h4 className={'m-2'} style={{color: '#fff',textAlign: 'left'}} >{tag.title}</h4>
                    <Row> {/* 根据 isMobile 动态调整 margin-left */}
                        {/* 卡片展示区 */}
                        <Col xs={12}>
                            <Row>
                                {/* 修改：使用 coursesByTag 展示对应标签的课程 */}
                                {coursesByTag[tag.id] && coursesByTag[tag.id].map((card, index) => (
                                    <Col key={index} xs={12} md={6} lg={4} xxl={3}
                                         style={{marginTop: '10px', marginBottom: '10px'}}>
                                        <div style={{
                                            position: 'relative',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}>
                                            <Card className={'w-100'}
                                                  style={{borderRadius: '8px', backgroundColor: '#313644'}}
                                                  onClick={() => navigate(`/courseInfo/${card.id}`)}
                                                  onMouseEnter={() => {
                                                      // if (videoRefs.current[card.id]) {
                                                      //     const video = videoRefs.current[card.id];
                                                      //     // 防止重复播放
                                                      //     if (video.paused) {
                                                      //         const playPromise = video.play();
                                                      //         if (playPromise !== undefined) {
                                                      //             playPromise.catch(error => {
                                                      //                 console.error('播放失败:', error);
                                                      //             });
                                                      //         }
                                                      //     }
                                                      // }
                                                  }}
                                                  onMouseLeave={() => {
                                                      // if (videoRefs.current[card.id]) {
                                                      //     const video = videoRefs.current[card.id];
                                                      //     video.pause();
                                                      //     video.currentTime = 0;
                                                      // }
                                                  }}>
                                                <div style={{
                                                    position: 'relative',
                                                    borderRadius: '8px',
                                                    display: 'flex',
                                                    background: 'linear-gradient(90deg, #02C8E3 30%, #9E22E2 130%)'
                                                }}>
                                                    {/*<Image src={card.cover} height={'200px'}/>*/}
                                                    <video
                                                        style={{
                                                            width: '100%',
                                                            height: '200px',
                                                            objectFit: 'contain',
                                                            borderRadius: '8px',
                                                        }}
                                                        src={card.videoContent}
                                                        preload="metadata"
                                                        poster={card.cover}
                                                        ref={(el) => {
                                                            videoRefs.current = {
                                                                ...videoRefs.current,
                                                                [card.id]: el
                                                            };
                                                        }}>
                                                    </video>

                                                </div>

                                                <Card.Body style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'space-between'
                                                }}>
                                             <span className="w-100" style={{
                                                 textAlign: 'left',
                                                 color: '#fff',
                                                 fontSize: '16px',
                                                 whiteSpace: "nowrap", /* 防止文本换行 */
                                                 overflow: "hidden", /* 超出部分隐藏 */
                                                 textOverflow: "ellipsis", /* 使用省略号表示被隐藏的文本 */
                                             }}>{card.title}</span>
                                                    <span style={{
                                                        textAlign: 'left',
                                                        alignContent: 'center',
                                                        color: '#697880',
                                                        fontSize: '14px'
                                                    }}>
                                            {card.user?.nickname ? card.user?.nickname : '沸推AI'} | {card.learningCount > 10000 ? card.learningCount / 10000 + '万' : card.learningCount}次学习
                                        </span>

                                                </Card.Body>
                                            </Card>

                                        </div>
                                    </Col>
                                ))}
                                {/* 修改结束 */}
                            </Row>
                        </Col>
                    </Row>
                </div>
            ))}


            <SVipModal visible={showSVipModal} onClose={() => setShowSVipModal(false)}/>

        </Container>
    );
}